import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { Row, Col, Form } from 'antd';
import { toString, forEach } from 'lodash';
import { connect } from 'react-redux';
import queryString from 'query-string';
import { withRouter } from 'react-router-dom';
import { Helmet } from 'react-helmet';

import helpers from 'utils/helpers';
import { setPasswordRequest } from 'ducks/auth';
import {
  FormTitle,
  StyledPasswordInput,
  StyledFormItem,
  StyledButton
} from 'components/Styled';

class SetPassword extends Component {
  state = {
    password: '',
    reEnterPassword: ''
  };

  gtmEvents = {
    // reserve use
    // email: `Inputted Login Email`,
    // password: `Inputted Login Password`
  };

  handleTextInputChange = (value, name) => {
    this.setState({
      [name]: value
    });
  };

  handleTextInputBlur = name => {
    if (this.gtmEvents[name]) {
      window.dataLayer.push({
        event: this.gtmEvents[name],
        loginInput: toString(this.state[name])
      });
    }

    this.setState({
      [name + 'Status']: this.validateError(name) ? 'error' : '',
      [name + 'Help']: this.validateError(name)
    });
  };

  validateType = {
    password: 'password',
    reEnterPassword: 'reEnterPassword'
  };

  validate = () => {
    const fields = ['password', 'reEnterPassword'];

    const states = {};
    forEach(fields, field => {
      states[field + 'Changed'] = true;
      states[field + 'Status'] = this.validateError(field) ? 'error' : '';
      states[field + 'Help'] = this.validateError(field);
    });

    this.setState(states);

    for (var i = 0; i < fields.length; i++) {
      if (this.validateError(fields[i])) {
        return false;
      }
    }
    return true;
  };

  validateError = name => {
    // let patterns;
    const value = toString(this.state[name]);

    const validatePassword = v => {
      if (v.length < 6) {
        return false;
      }

      let letter = false;
      let number = false;
      for (let i = 0; i < v.length; i++) {
        if (!number && /^[0-9]$/.test(v[i])) {
          number = true;
        }
        if (!letter && /^[a-zA-Z]$/.test(v[i])) {
          letter = true;
        }
      }

      return number && letter;
    };

    switch (this.validateType[name]) {
      case 'password':
        if (value === '') {
          return `auth.err_msg.${name}.empty`;
        }
        if (!validatePassword(value)) {
          return `auth.err_msg.${name}.format`;
        }
        return null;
      case 'reEnterPassword':
        if (value === '') {
          return `auth.err_msg.${name}.empty`;
        }
        if (value !== this.state.password) {
          return `auth.err_msg.${name}.format`;
        }

        return null;
      default:
        return null;
    }
  };

  handleAction = () => {
    if (!this.validate()) {
      return helpers.scrollToError();
    }

    const params = queryString.parse(this.props.location.search);

    this.props.setPasswordRequest({
      password: this.state.password,
      token: params.token
    });
  };

  toRegister = () => {
    this.props.onPageChange('register');
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (!prevProps.passwordChanged && this.props.passwordChanged) {
      this.props.history.push(
        `${process.env.PUBLIC_URL}/create-shipment/quotation`
      );
    }
  }

  componentDidMount() {
    window.dataLayer.push({
      event: 'Land Set Password'
    });
  }

  render() {
    return (
      <React.Fragment>
        <Helmet>
          <title>{this.props.t('auth.set_password.header.title')}</title>
        </Helmet>
        <div
          style={{
            padding: '0 15px 10px',
            flex: '1 0 auto',
            backgroundColor: '#fafafa',
            margin: '0 auto',
            width: '100%',
            maxWidth: `${process.env.REACT_APP_MAX_WIDTH}px`
          }}>
          <div style={{ padding: '50px 0 45px', textAlign: 'center' }}>
            <div style={{ fontSize: '20px', fontWeight: 700 }}>
              {this.props.t('auth.set_password.set_up')}
            </div>
            <div style={{ fontSize: '12px', paddingTop: '5px' }}>
              {this.props.t('auth.set_password.first_login')}
            </div>
          </div>
          <Form>
            <div style={{ padding: '' }}>
              <Row type="flex" justify="space-between" align="bottom">
                <Col>
                  <FormTitle>{this.props.t('auth.form.password')}</FormTitle>
                </Col>
                <Col>
                  <FormTitle
                    style={{
                      fontWeight: 400,
                      textAlign: 'right',
                      fontSize: '10px',
                      color: '#2C2C2E'
                    }}>
                    {this.props.t('auth.form.password_format')}
                  </FormTitle>
                </Col>
              </Row>
              <StyledFormItem
                validateStatus={this.state['passwordStatus'] || ''}
                help={this.props.t(this.state['passwordHelp'])}>
                <StyledPasswordInput
                  size="large"
                  value={this.state['password']}
                  onChange={e => {
                    this.handleTextInputChange(e.target.value, 'password');
                  }}
                  onBlur={e => {
                    this.handleTextInputBlur('password');
                    if (this.state.reEnterPassword.length) {
                      this.handleTextInputBlur('reEnterPassword');
                    }
                  }}
                />
              </StyledFormItem>
              <FormTitle style={{ paddingTop: '20px' }}>
                {this.props.t('auth.form.re_password')}
              </FormTitle>
              <StyledFormItem
                validateStatus={this.state['reEnterPasswordStatus'] || ''}
                help={this.props.t(this.state['reEnterPasswordHelp'])}>
                <StyledPasswordInput
                  size="large"
                  value={this.state['reEnterPassword']}
                  onChange={e => {
                    this.handleTextInputChange(
                      e.target.value,
                      'reEnterPassword'
                    );
                  }}
                  onBlur={e => {
                    this.handleTextInputBlur('reEnterPassword');
                  }}
                />
              </StyledFormItem>
            </div>
            <div style={{ padding: '15px 0' }}>
              <StyledButton
                onClick={this.handleAction}
                type="primary"
                loading={this.props.loading}
                htmlType="submit"
                shadow
                block>
                {this.props.t('button.confirm')}
              </StyledButton>
            </div>
          </Form>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    loading: !!state.auth.loading,
    passwordChanged: !!state.auth.passwordChanged
  };
};

const mapDispatchToProps = {
  setPasswordRequest
};

export default withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(withRouter(SetPassword))
);
